<script setup lang="ts">
  import { computed, inject, useId } from 'vue';
  import TundrLogo from '../TundrLogo/TundrLogo.vue';
  import { TundrLogoVariant } from '../TundrLogo/TundrLogo.types';
  import AppVersion from '../AppVersion/AppVersion.vue';
  import { AppVersionTone } from '../AppVersion/AppVersion.types';
  import type { AuthPageLayoutProps } from './AuthPageLayout.types';
  import {
    bottomClass,
    footerClass,
    leftSectionClass,
    leftSectionContentClass,
    logoWrapperClass,
    mainContainerClass,
    mainContentBackgroundClass,
    mainContentClass,
    messageClass,
  } from './AuthPageLayout.css';

  const props = defineProps<AuthPageLayoutProps>();

  const uid = useId();
  const resolvedTestId = computed(
    () => props.testId ?? `ds-auth-page-layout-${uid}`,
  );

  const appVersion = inject<string>('appVersion', '');
</script>

<template>
  <div :id="id" :class="mainContainerClass" :data-testid="resolvedTestId">
    <div :class="leftSectionClass">
      <div :class="leftSectionContentClass">
        <div :class="logoWrapperClass">
          <TundrLogo :variant="TundrLogoVariant.Light" />
        </div>
        <slot name="message">
          <p v-if="message" :class="messageClass">{{ message }}</p>
        </slot>
      </div>
      <div v-if="$slots.footer || appVersion" :class="bottomClass">
        <div
          v-if="$slots.footer"
          :class="footerClass"
          :data-testid="`${resolvedTestId}-footer`"
        >
          <slot name="footer" />
        </div>
        <AppVersion v-if="appVersion" :tone="AppVersionTone.OnBrandMuted" />
      </div>
    </div>
    <main :class="mainContentBackgroundClass">
      <slot name="content">
        <div :class="mainContentClass"><slot /></div>
      </slot>
    </main>
  </div>
</template>
